export const config = {
    production: false,
    endPointURL: 'https://recovery-api-management-staging-v2.azure-api.net/api/tenant/',
    claimsEndPointURL: 'https://recovery-api-management-staging-v2.azure-api.net/api/claims/',
    intHubURL: 'https://recovery-api-management-staging-v2.azure-api.net/api/inthub/',

    encryptionKey: 'WAgwm7f3!cMeqS&r*!K?Wq9qfteX5kXH',

};